var InFlight = InFlight || {};

InFlight.i18n = (function () {
  var setupPromise = undefined;
  var language = 'en';
  // Cached translations are revalidated after this long so a deploy is picked up
  // without requiring the user to clear storage or close the browser.
  var CACHE_TTL_MS = 20 * 60 * 1000; // 20 minutes

  function isCacheStale(cachedAt) {
    var cachedAtMs = Number(cachedAt);
    return !cachedAtMs || (Date.now() - cachedAtMs) > CACHE_TTL_MS;
  }

  function setupLanguage() {
    setupPromise = new Promise(function (resolve, reject) {
      var languageObj = {};
      var storedLanguage = localStorage.getItem('language');
      var storedLanguageData = sessionStorage.getItem('languageData');
      var storedLanguageCachedAt = sessionStorage.getItem('languageDataCachedAt');
      if (storedLanguage) {
        language = storedLanguage;
      }
      if (storedLanguageData && !isCacheStale(storedLanguageCachedAt)) {
        languageObj = JSON.parse(storedLanguageData);
      }
      if (languageObj[language]) {
        //loadLanguage(language, languageObj);
        $.i18n({ locale: language })
          .load(languageObj)
          .done(function () {
            resolve();
          });
      } else {
        $.ajax({
          url: InFlight.NLX.Cfg.Customer.getI18nEnJson(),
          dataType: 'json',
          cache: false // avoid the browser serving a stale cached copy of the JSON
        })
          .done(function (data) {
            languageObj[language] = data;
            //  loadLanguage(language, languageObj);
            sessionStorage.setItem('languageData', JSON.stringify(languageObj));
            sessionStorage.setItem('languageDataCachedAt', Date.now().toString());
            $.i18n({ locale: language })
              .load(languageObj)
              .done(function () {
                resolve();
              });
          })
          .fail(function () {
            reject();
          });
      }
    });
  }

  function localize(language, languageObj) {
    setupPromise.then(function () {
      preProcessIFDatai18n();
      $('body').i18n();
    });
  }

  function preProcessIFDatai18n() {
    var i18nElements = $('body [data-if-i18n]');
    for (var i = 0; i < i18nElements.length; i++) {
      var $i18n = $(i18nElements[i]);
      var attr = $i18n.data('if-i18n');
      var split = attr.split(' ');
      for (var j = 0; j < split.length; j++) {
        var term = split[j];
        var splitTerm = term.split(':');
        if (splitTerm.length === 1) {
          $i18n.data('i18n', splitTerm[0]);
        } else {
          $i18n.attr(splitTerm[0], $.i18n(splitTerm[1]));
        }
      }
    }
  }

  function getTerm(langTerm) {
    var languageData = JSON.parse(sessionStorage.getItem('languageData'));
    if (languageData) {
      return languageData[language][langTerm];
    }

  }

  function clearLanguage() {
    sessionStorage.removeItem('languageData');
    sessionStorage.removeItem('languageDataCachedAt');
  }

  return {
    setup: setupLanguage,
    localize: localize,
    clear: clearLanguage,
    getTerm: getTerm
  };
})();
